import { Component, HostListener, inject, input, model, OnChanges, output, signal, SimpleChanges } from "@angular/core";
import { Router } from "@angular/router";
import { ListActionInterface, ListActionSimpleRouteType, ListActionRouteType } from "../../../interfaces/listing-items-actions.interface";
import { TableComponent } from "../table/table.component";
import { GraphService } from "../../../../graphql/services/graph.service";
import { ToastService } from "../../../../tools/message/service/toast.service";
import { TableRowRefModel } from "../../models/table-row-ref.model";
import { Tooltip } from "primeng/tooltip";
import { TranslatePipe } from "@ngx-translate/core";
import { SvgIconComponent } from "../../../../tools/svg-icon/components/svg-icon/svg-icon.component";

@Component({
  selector: "sxw-table-action",
  templateUrl: "./table-action.component.html",
  styleUrls: ["./table-action.component.scss"],
  imports: [TranslatePipe, SvgIconComponent, Tooltip],
  host: {
    "[class.hidden]": "!visible()",
  },
})
export class TableActionComponent implements OnChanges {
  action = input<ListActionInterface>({});
  data = input<any[]>([]);
  visibleChange = output<boolean>();

  public index = input(0);

  visible = signal(false);

  private parent = inject(TableComponent);
  constructor(
    private router: Router,
    private graphService: GraphService,
    private messageService: ToastService
  ) {}

  @HostListener("click")
  executeAction() {
    this.execute();
  }

  /**
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes["action"]) {
      this.processAction()
        .then()
        .catch(e => {
          console.error(e);
        });
    }
  }

  /**
   * Runs When the action is executed.
   */
  async execute(): Promise<any> {
    // If the action perform is a function, execute that function.
    if (typeof this.action().perform === "function") {
      await this.action().perform!(new TableRowRefModel(this.data(), this.index(), this.parent, this.graphService, this.messageService));
    }
    // If the action has route then navigate to that route.
    if (this.action().route) {
      return this.navigate(this.action().route!);
    }
  }

  /**
   * Execute Navigate Functionality.
   * @param route
   * @protected
   */
  protected navigate(route: ListActionRouteType): Promise<boolean> {
    let _route: ListActionSimpleRouteType;
    // if the route is a function, then execute it to get the simple route.
    if (typeof route === "function") {
      _route = route(this.data()[this.index()], this.index());
    } else {
      _route = route;
    }
    if (Array.isArray(_route)) {
      return this.router.navigate(_route);
    }
    return this.router.navigate(_route.route, _route.extras);
  }

  /**
   * Prepares data to be used in the view
   */
  async processAction(): Promise<void> {
    // If the action.visible is a function then execute it and set the visible value to what it returns.
    const _visible = this.action().visible;
    if (typeof _visible === "function") {
      const isVisible = await _visible(this.data()[this.index()]);
      this.visible.set(!!isVisible);
    }
    // If the action.visible is boolean then use its value.
    else if (typeof _visible === "boolean") {
      this.visible.set(_visible);
    }
    // If no visibility logic is assigned, then set the action to be visible as default.
    else {
      this.visible.set(true);
    }
    this.visibleChange.emit(this.visible());
  }
}
